import React from 'react';
import styled from 'styled-components';
import { useTabs } from './useTab';


// Tipos
type Role = {
    id: string | number;
    name: string;
    };

    type TabsProps = {
        setTabSelect: (role: Role) => void;
        tabSelect: Role | null;
        perfil: string;
    };

    // Estilos tipados
    const TabContainer = styled.div`
        display: flex;
        border-bottom: 1px solid #ccc;
        margin-left: 20px;
        margin-right: 20px;
    `;

    const Tab = styled.div<{ active: boolean }>`
        flex: 1;
        padding: 10px 20px;
        cursor: pointer;
        text-align: center;
        border-bottom: ${({ active }) => (active ? '3px solid #e4002b' : 'none')};
        font-weight: ${({ active }) => (active ? 'bold' : 'normal')};
        color: ${({ active }) => (active ? '#e4002b' : '#555')};

        &:hover {
            background-color: #f5f5f5;
        }

        @media (max-width: 600px) {
            padding: 10px;
            font-size: 14px;
        }
    `;

const Tabs: React.FC<TabsProps> = ({ setTabSelect, tabSelect, perfil }) => {

    const { roles, selectTab } = useTabs(setTabSelect, tabSelect, perfil);
    return (
        <TabContainer>
            {roles.map((role) => (
                <Tab
                key={role.id}
                active={role.id === tabSelect?.id}
                onClick={() => selectTab(role)}
                >
                {role.name}
                </Tab>
            ))}
        </TabContainer>
    );
};

export default Tabs;
